import { View, XStack, YStack } from 'tamagui';

import PSBox from '@/components/ui/PSBox';
import PSButton from '@/components/ui/PSButton';
import PSText from '@/components/ui/PSText';
import type { PerkUsage } from '@/src/api/authApi';
import { dateParts } from '@/src/utils/dateFormatter';

const bookedLine = (perk: PerkUsage) =>
  perk.isUnlimited
    ? `${perk.bookings} Booked`
    : `${perk.bookings} / ${perk.limit} Booked`;

// Sits on the home page's $brandDark band, above UpcomingBookingsSection.
export default function TrialPassSection({
  expiresAt,
  perks,
  onUpgrade,
}: {
  expiresAt: string | null;
  perks: PerkUsage[];
  onUpgrade: () => void;
}) {
  const validUntil = expiresAt && dateParts(expiresAt);

  return (
    <YStack gap="$space.md">
      <XStack items="center" justify="space-between">
        <PSText.H2 color="$color.textWhite">Your trial</PSText.H2>
        {validUntil && (
          <PSText.Body4 color="$color.textWhiteMuted">
            Valid until {validUntil.day} {validUntil.month}
          </PSText.Body4>
        )}
      </XStack>
      {perks.length > 0 && (
        <PSBox
          bg="$color.panelTranslucent"
          borderColor="$color.transparent"
          gap="$space.sm"
        >
          {perks.map((perk) => (
            <XStack key={perk.label} justify="space-between" gap="$space.md">
              <PSText.Body3 flex={1} color="$color.textWhite">
                {perk.label}
              </PSText.Body3>
              <PSText.Body3 color="$color.success">
                {bookedLine(perk)}
              </PSText.Body3>
            </XStack>
          ))}
        </PSBox>
      )}
      <PSButton title="Upgrade to Access Pass" onPress={onUpgrade} fullWidth />
      <View
        mt="$space.xs"
        borderTopWidth="$borderWidth.hairline"
        borderColor="$color.panelTranslucent"
      />
    </YStack>
  );
}
